import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import Endpoints from "../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, } from "../../base";
import { RemoteFetchDepartmentMaster } from "../../data/usecases/remote-fetch-department-master";
import { FetchDepartmentMaster } from "../../domain/useages/fetch-department-master";
import { DepartmentType } from "../../domain/models/department-type";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchDepartmentInterface {
  departmentData: DepartmentType[];
  fetchDepartment: Function;
}

const initialStates = {
  departmentData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchDepartmentSlice: StateCreator<FetchDepartmentInterface> = (
  set
) => ({
  ...initialStates,
  fetchDepartment: async () => {
        const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
        const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchDepartmentMaster: FetchDepartmentMaster =
      new RemoteFetchDepartmentMaster(
        `${BASE_URL}${Endpoints.FETCH_DEPARTMENTS}`,
        axiosHttpClient
      );

    set(() => ({ departmentData: [] }));

    let result = await remoteFetchDepartmentMaster.fetch();
    if (result.departments) {
      set(() => ({ departmentData: result.departments }));
    }
  },
});
